import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { QRCodePage } from './pages/QRCodePage';
import { DashboardPage } from './pages/DashboardPage';
import { ListsPage } from './pages/ListsPage';
import { ListDetailsPage } from './pages/ListDetailsPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { CreateCampaignPage } from './pages/CreateCampaignPage';
import { CampaignDetailsPage } from './pages/CampaignDetailsPage';
import { NumbersPage } from './pages/NumbersPage';
export function AppRouter() {
  // This would normally come from authentication state
  const isLoggedIn = false;
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/login" element={<LoginPage data-id="element-4" />} data-id="element-3" />
        {/* Protected Routes */}
        <Route element={<Layout data-id="element-6" />} data-id="element-5">
          <Route path="/qrcode" element={<QRCodePage data-id="element-8" />} data-id="element-7" />
          <Route path="/dashboard" element={<DashboardPage data-id="element-10" />} data-id="element-9" />
          <Route path="/numbers" element={<NumbersPage data-id="element-12" />} data-id="element-11" />
          <Route path="/lists" element={<ListsPage data-id="element-14" />} data-id="element-13" />
          <Route path="/lists/:listId" element={<ListDetailsPage data-id="element-16" />} data-id="element-15" />
          <Route path="/campaigns" element={<CampaignsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/campaigns/create" element={<CreateCampaignPage data-id="element-20" />} data-id="element-19" />
          <Route path="/campaigns/:campaignId" element={<CampaignDetailsPage data-id="element-22" />} data-id="element-21" />
        </Route>
        {/* Redirects */}
        <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" data-id="element-24" /> : <Navigate to="/login" data-id="element-25" />} data-id="element-23" />
      </Routes>
    </BrowserRouter>;
}